import React from "react"
import { Link } from "react-router-dom"
import lystfacelogolg from "../../../assets/images/lystfacelogos/lystfacelogolg.svg"
import lystfacelogosm from "../../../assets/images/lystfacelogos/lystfacelogosm.svg"
import PropTypes from "prop-types"
import { appConstants } from "../../../constants/app_constants"
import { devUrls, urls } from "../../../config"

const NonAuthHeader = ({ isLogin }) => {
  let logoSM = appConstants.logoSm
  let logoDark = appConstants.lfLogoDark
  return (
    <div className="main-header">
      <div className="container custom-container">
        <div className="main-header-logo">
          <div>
            <a href={process.env.REACT_APP_NODE !== "prod" ? devUrls.lfLanding : urls.lfLanding} target="_blank">
              <img src={logoSM} className="d-md-none" />
              <img src={logoDark} className="d-none d-md-block" />
            </a>
          </div>
          <div>
            <span className="me-3">
              {isLogin
                ? `New to ${appConstants.cName}?`
                : `Already have an account?`}
            </span>
            <Link to={isLogin ? `/signup` : `/login`}>
              <button>
                {isLogin ? `Signup` : `Login`}
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NonAuthHeader

NonAuthHeader.propTypes = {
  login: PropTypes.bool,
}
